<template>
    <div class="link">
        <el-popover placement="right" :title="$t('zhiji.answer.answerDetail')" width="400" trigger="hover" @show="mouseOnQuestion">
            <template slot="reference">
                <span :class="{ disabled: data.disabled }" @click="clickHandler">{{ data.value }}</span>
            </template>
            <p>{{ simpleContent }}</p>
        </el-popover>
        <a>
            <el-tag v-show="'ext_id' in row.addData" class="ext-content">
                {{ MatchMsg }}
            </el-tag>
        </a>
    </div>
</template>

<script>
import QuestionEditModal from "@/views/zhiji/components/questionEdit/QuestionEditModal.vue";

export default {
    name: "StandQuestion",
    props: ["data", "row", "col"],
    data() {
        return {
            isShowSimple: false,
            simpleContent: ""
        };
    },
    computed: {
        MatchMsg() {
            let msg = "";
            if (this.row.isSensitiveWords) {
                msg = this.$t("zhiji.knowlege.matchSensitiveWords")
            } else if (this.row.noAnswerQuestion) {
                msg = this.$t("zhiji.knowlege.reveal")
            } else {
                msg = this.$t("zhiji.knowlege.matchedStandardQues") + `【${this.row.addData.hit_query}】`;
            }
            return msg;
        }
    },
    methods: {
        clickHandler() {
            if (!this.row.questionId) {
                return;
            }
            this.$store.dispatch("zhiji/showModal", {
                type: QuestionEditModal,
                data: {
                    questionId: this.row.questionId,
                    curPanel: "AnswerPanel",
                    hasRecommendSimilar: false,
                    saveHandler: () => {}
                }
            });
        },
        mouseOnQuestion() {
            this.simpleTimeout && clearTimeout(this.simpleTimeout);
            this.simpleTimeout = setTimeout(() => {
                this.isShowSimple = true;
                if (this.row.questionId) {
                    this.zhiji
                        .requestByServiceName("queryQuesSimpleById", {
                            questionId: this.row.questionId
                        })
                        .then(resp => {
                            this.simpleContent = resp.answerText !== "null" ? resp.answerText : "null";
                        });
                }
            }, 500);
        }
    }
};
</script>

<style lang="less" scoped>
.link {
    position: relative;
    display: flex;
    align-items: center;
    &:hover > span {
        cursor: pointer;
        color: #2ec2ff;
        text-decoration: underline;
    }

    .ext-content {
        margin-left: 10px;
        max-width: 230px;
        overflow: hidden;
        text-overflow: ellipsis;
}
}
.disabled {
    pointer-events: none;
}
</style>
